<template>
    <transition name="fade">
    <div v-if="isShowing" class="die" :class="{ isOne: value === 1, isSix: value === 6 }">
        <p>{{ value }}</p>
    </div>
    </transition>
</template>

<script>
export default {
    name:"RandDice",
    emits:['roll', 'rerollOne','disable'],
    props:{
        rollValue: Number,
        isThem: Boolean
    },
    created() {
        this.animateIn()
    },
    data() {
        return {
            value: this.rollValue,
            shuffles: 5,
            currentShuffleAmount: 0,
            shuffleTimeout: 100,
            isShowing: false,
            isDisabled: false,
            rollContinously: false
        }
    },
    methods: {
        roll(){
            if(this.isDisabled) return;
            this.isShowing = !this.isShowing;
            this.value = Math.ceil(Math.random()*6)
            setTimeout(()=> {
                if(this.rollContinously){ 
                    this.currentShuffleAmount = 0;
                    this.roll();
                    }
                else if (this.currentShuffleAmount <= this.shuffles){
                    this.currentShuffleAmount++;
                    this.roll();
                }
                else{
                    this.isShowing = false;
                    this.currentShuffleAmount = 0;
                    this.animateIn();
                    
                }
            },
            this.shuffleTimeout)
        },
        toggleRolling(res){
            this.rollContinously = res;
        },
        animateIn(){
            let animateInTimeout = this.shuffleTimeout + 800;
            setTimeout(() => {this.isShowing = true}, animateInTimeout);            
        },
        removeOne(){
            if(this.value !== 1 || this.isDisabled) return false;
            this.disable();
            return true;
        },
        rerollOne() {
            if(this.value !== 1) return;
            this.roll();
        },
        disable() {
            this.isShowing = false;
            this.isDisabled = true;
        },
        returnDie() {
            if(!this.isDisabled) return;
            this.isDisabled = false;
            this.isShowing = true;
        }
    }
}
</script>

<style scoped>
    .die{
        width: 3rem;
        height: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.205);
        border-radius: 5px;
        font-size: 1.25rem;
    }

    .isSix {
        background-color: rgb(221, 168, 23);
                border-color: white;

        box-shadow: 0 0 10px 2px rgb(236, 193, 113);
    }
    .isOne {
        background-color: rgb(63, 9, 9);
                border-color: white;

        box-shadow: 0 0 10px 2px rgb(241, 117, 117);

    }


    .fade-leave-active, .fade-enter-active {
        transition: opacity 400ms ease-out;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 1%;
    }

</style>